/**
 * Updates the mini basket button.
 * @param {any} response - The response object containing updated basket HTML.
 */
export function updateMiniBasketBtn(response: any): void {
	const btnHtml =
		'<i class="fas fa-shopping-basket"></i>' +
		'<div class="float-right d-none d-sm-inline">' +
		'<p><small>Basket total</small></p>' +
		'<p><small><strong>' +
		response.subtotal +
		'</strong></small></p>' +
		'</div>';

	// Get the element and ensure it is not null
	const miniBasketBtn = document.getElementById('mini-basket-btn');
	if (miniBasketBtn) {
		miniBasketBtn.innerHTML = btnHtml;
		miniBasketBtn.removeAttribute('disabled');
	} else {
		console.error("Element with id 'mini-basket-btn' not found.");
	}
}
